"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _axios = _interopRequireDefault(require("axios"));

var _reactPerfectScrollbar = _interopRequireDefault(require("react-perfect-scrollbar"));

var _reactDeviceDetect = require("react-device-detect");

var _formik = require("formik");

var _moment = _interopRequireDefault(require("moment"));

var _ = require("../");

var _utils = require("../utils");

var _schema = require("./schema");

var _SignupBanner = _interopRequireDefault(require("./SignupBanner"));

var _SignupForm = _interopRequireDefault(require("./SignupForm"));

require("react-perfect-scrollbar/dist/css/styles.css");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  flex: 1 1 auto;\n  background: #efefef;\n"])));

var StyledCardWrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  max-height: 70%;\n  width: 100%;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n\n  @media (min-width: ", ") {\n    max-height: 70%;\n  }\n"])), function (props) {
  return props.theme.screenWidthMd;
});

var StyledCard = (0, _styledComponents.default)(_reactPerfectScrollbar.default)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  flex: 1;\n  background: white;\n  margin: 0 1rem;\n  padding: 1.5rem;\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.borderRadius;
});
var initialValues = {
  name: "",
  favClub: "",
  mobileNumber: "",
  pin: "",
  adSubscribe: false,
  emailNotificationsAccepted: false,
  over18: false,
  agreedTerms: false,
  birthDate: ""
};
var verifyInitialValues = {
  code: ""
};

if (process.env.NODE_ENV === "development") {
  initialValues.name = "ruud";
  initialValues.birthDate = "1975-01-01";
  initialValues.pin = "1234";
  initialValues.mobileNumber = "0777777777";
  initialValues.favClub = "Sparta";
  initialValues.agreedTerms = true;
}

var Signup = function Signup(_ref) {
  var translations = _ref.translations,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      onPageButtonClicked = _ref.onPageButtonClicked,
      onLanguageChanged = _ref.onLanguageChanged,
      dpgUserId = _ref.dpgUserId,
      dpgEmail = _ref.dpgEmail,
      brand = _ref.brand,
      termsSlug = _ref.termsSlug,
      bannerImageUrl = _ref.bannerImageUrl,
      language = _ref.language;

  var _useState = (0, _react.useState)({
    signupError: undefined,
    location: "Unknown",
    dialingCode: ""
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      question = _useState4[0],
      setQuestion = _useState4[1];

  var onLocationSuccess = function onLocationSuccess(_ref2) {
    var country = _ref2.country,
        dialingCode = _ref2.dialingCode;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      location: country,
      dialingCode: dialingCode
    }));
  };

  (0, _.useIpLocation)(onError, onLocationSuccess);
  var activeStep = state.activeStep,
      location = state.location,
      signupError = state.signupError,
      dialingCode = state.dialingCode,
      isSignedUp = state.isSignedUp;
  var showFallbackDatePicker = _reactDeviceDetect.isSafari && !_reactDeviceDetect.isMobileSafari || _reactDeviceDetect.isIE || _reactDeviceDetect.isAndroid;

  var validate = function validate(values) {
    var errors = {};

    if ((0, _utils.validateAge)(values.birthDate, showFallbackDatePicker) === undefined) {
      errors.birthDate = "".concat(translations.invalid, " ").concat(translations.birthDate);
    } else if ((0, _utils.validateAge)(values.birthDate, showFallbackDatePicker) === false) {
      errors.birthDate = translations.birthDateError;
    } else if (values.birthDate.length !== 10) {
      errors.birthDate = "".concat(translations.invalid, " ").concat(translations.birthDate);
    }

    if (!/^[0-9]*$/.test(values.pin)) {
      errors.pin = translations.changePinValidation;
    }

    return errors;
  };

  var validateVerify = function validateVerify(values) {
    var errors = {};

    if (!/^[0-9]*$/.test(values.code)) {
      errors.code = translations.confirmPhoneValidationNumbers;
    }

    return errors;
  };

  var onSubmit = function onSubmit(values, _ref3) {
    var setSubmitting = _ref3.setSubmitting,
        resetForm = _ref3.resetForm;
    var params = {
      location: location,
      dpgUserId: dpgUserId,
      language: language,
      notificationBrand: brand,
      birthDate: showFallbackDatePicker ? new _moment.default(values.birthDate, "DD/MM/YYYY", true).format("YYYY-MM-DD") : values.birthDate,
      name: values.name,
      mobileNumber: "+".concat(dialingCode).concat(values.mobileNumber - 0),
      pin: values.pin,
      termsConditionsAccepted: values.agreedTerms,
      email_notifications_accepted: values.emailNotificationsAccepted,
      favorite_team: values.favClub
    };

    _axios.default.post("/auth/register-dpg", params).then(function (_ref4) {
      var data = _ref4.data;
      var access_token = data.access_token;
      resetForm(values);
      setSubmitting(false);
      window.xtremepush("tag", "newSignup", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE,
        name: values.name
      }));
      window.xtremepush("tag", "favFootballClub", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE,
        favClub: values.favClub
      }));

      if (values.adSubscribe) {
        _axios.default.put("/dpg-subscriptions", {
          subscribe: true,
          notificationBrand: brand,
          email: dpgEmail,
          questionId: question.question_id
        }).then(function () {
          onSuccess({
            accessToken: access_token
          });
        }).catch(function (response) {
          onError(response);
          onSuccess({
            accessToken: access_token
          });
        });
      } else {
        onSuccess({
          accessToken: access_token
        });
      }
    }).catch(function (error) {
      var message = JSON.stringify(error);

      if (error) {
        var _response$data;

        var response = error.response;

        if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 'low6UserExists') {
          message = translations.low6UserExists;
        } else if (response && response.data) {
          if (response.data.errors) {
            if (response.data.errors.mobileNumber) {
              message = "".concat(translations.invalid, " ").concat(translations.mobileNumber);
            } else if (response.data.errors.birthDate) {
              message = "".concat(translations.invalid, " ").concat(translations.birthDate);
            } else if (response.data.errors.dpgUserId) {
              message = translations.alreadyHaveAccount;
            } else {
              var _response$data2;

              message = JSON.stringify(response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.errors);
            }
          } else if (response.data.message) {
            message = response.data.message;
          } else {
            message = JSON.stringify(response.data);
          }
        }
      }

      setSubmitting(false);
      setState(_objectSpread(_objectSpread({}, state), {}, {
        signupError: message
      }));
      onError(error);
    });
  };

  (0, _react.useEffect)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _questionRes$data, _questionRes$data$dat, questionRes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!brand) {
              _context.next = 11;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return _axios.default.get("dpg-subscription/questions/".concat(brand));

          case 4:
            questionRes = _context.sent;
            setQuestion(questionRes === null || questionRes === void 0 ? void 0 : (_questionRes$data = questionRes.data) === null || _questionRes$data === void 0 ? void 0 : (_questionRes$data$dat = _questionRes$data.data) === null || _questionRes$data$dat === void 0 ? void 0 : _questionRes$data$dat.questions[0]);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            onError(_context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  })), [brand]);
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(_SignupBanner.default, {
    bannerImageUrl: bannerImageUrl
  }), /*#__PURE__*/_react.default.createElement(StyledCardWrapper, null, /*#__PURE__*/_react.default.createElement(StyledCard, null, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: initialValues,
    validationSchema: (0, _schema.SignupSchema)(translations),
    validate: validate,
    onSubmit: onSubmit
  }, function (_ref6) {
    var _React$createElement;

    var isValid = _ref6.isValid,
        values = _ref6.values,
        errors = _ref6.errors,
        touched = _ref6.touched,
        dirty = _ref6.dirty,
        handleChange = _ref6.handleChange,
        handleBlur = _ref6.handleBlur,
        handleSubmit = _ref6.handleSubmit,
        isSubmitting = _ref6.isSubmitting,
        setFieldValue = _ref6.setFieldValue,
        setValues = _ref6.setValues;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_SignupForm.default, (_React$createElement = {
      language: language,
      question: question,
      brand: brand,
      dpgEmail: dpgEmail,
      translations: translations,
      dialingCode: dialingCode,
      isValid: isValid,
      values: values,
      errors: errors,
      touched: touched,
      dirty: dirty,
      showFallbackDatePicker: showFallbackDatePicker,
      signupError: signupError,
      handleChange: handleChange,
      handleBlur: handleBlur,
      handleSubmit: handleSubmit,
      isSubmitting: isSubmitting,
      termsSlug: termsSlug
    }, _defineProperty(_React$createElement, "language", language), _defineProperty(_React$createElement, "onLanguageChanged", onLanguageChanged), _defineProperty(_React$createElement, "onError", onError), _defineProperty(_React$createElement, "onPageButtonClicked", onPageButtonClicked), _React$createElement)));
  }))));
};

var _default = Signup;
exports.default = _default;